var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4004 0C13.8404 0 0.400391 13.44 0.400391 30C0.400391 46.56 13.8404 60 30.4004 60C46.9604 60 60.4004 46.56 60.4004 30C60.4004 13.44 46.9604 0 30.4004 0ZM22.2704 42.87L11.5004 32.1C10.3304 30.93 10.3304 29.04 11.5004 27.87C12.6704 26.7 14.5604 26.7 15.7304 27.87L24.4004 36.51L45.0404 15.87C46.2104 14.7 48.1004 14.7 49.2704 15.87C50.4404 17.04 50.4404 18.93 49.2704 20.1L26.5004 42.87C25.3604 44.04 23.4404 44.04 22.2704 42.87Z",
    fill: "#188923"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/green-tick.97f7a7554f1bc2c564d0cd271fb52820.svg";
export { ForwardRef as ReactComponent };